import script from "./Box.vue?vue&type=script&setup=true&lang=js"
export * from "./Box.vue?vue&type=script&setup=true&lang=js"

import "./Box.vue?vue&type=style&index=0&id=6406c9b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6406c9b6"]])

export default __exports__